<template>
  <q-markup-table
    separator="cell"
    flat
    bordered
    dense
  >
    <thead>
      <tr>
        <th>Amount Due</th>
        <th>Net</th>
        <th>{{ $t('pricing.tax') }}</th>
        <th>Gross</th>
      </tr>
    </thead>
    <tbody>
      <tr class="top-total-row">
        <td class="bold-label">
          Price
        </td>
        <td class="cell-value">
          <formatted-number
            :value="originalSubtotal(orderItem)"
          />
        </td>
        <td class="cell-value">
          <formatted-number
            v-if="orderItem.hasTax"
            :value="originalTax(orderItem)"
          />
          <div v-else>
            n/a
          </div>
        </td>
        <td class="cell-value">
          <formatted-number
            :value="originalTotal(orderItem)"
          />
        </td>
      </tr>
      <tr>
        <td
          v-if="orderItem.voucherType || orderItem.voucher"
          class="sub-label ellipsis"
          style="max-width: 200px;"
        >
          Voucher — {{ orderItem.displayVoucherName }}
        </td>
        <td
          v-else
          class="sub-label"
        >
          No Voucher Applied
        </td>
        <td class="cell-value">
          <formatted-number
            :value="-orderItem.voucherAmount"
          />
        </td>
        <td class="cell-value">
          <formatted-number
            v-if="orderItem.hasTax"
            :value="-orderItem.taxFromNet(orderItem.voucherAmount)"
          />
          <div v-else>
            n/a
          </div>
        </td>
        <td class="cell-value">
          <formatted-number
            :value="-voucherTotal(orderItem)"
          />
        </td>
      </tr>
      <tr>
        <td
          v-if="orderItem.discount"
          class="sub-label ellipsis"
          style="max-width: 200px;"
        >
          Discount — {{ orderItem.discount.displayName }}
        </td>
        <td
          v-else
          class="sub-label"
        >
          No Discount Applied
        </td>
        <td class="cell-value">
          <formatted-number
            :value="-orderItem.discountAmount"
          />
        </td>
        <td class="cell-value">
          <formatted-number
            v-if="orderItem.hasTax"
            :value="-orderItem.taxFromNet(orderItem.discountAmount)"
          />
          <div v-else>
            n/a
          </div>
        </td>
        <td class="cell-value">
          <formatted-number
            :value="-discountTotal(orderItem)"
          />
        </td>
      </tr>
      <tr>
        <td
          class="sub-label"
        >
          Rounding Adjustments
        </td>
        <td class="cell-value">
          <formatted-number
            :value="orderItem.subtotal - (originalSubtotal(orderItem) - orderItem.discountAmount - orderItem.voucherAmount)"
          />
        </td>
        <td class="cell-value">
          <formatted-number
            v-if="orderItem.hasTax"
            :value="orderItem.taxAmount - (originalTax(orderItem) - orderItem.taxFromNet(orderItem.discountAmount) - orderItem.taxFromNet(orderItem.voucherAmount))"
          />
          <div v-else>
            n/a
          </div>
        </td>
        <td class="cell-value">
          <formatted-number
            :value="orderItem.total - (originalTotal(orderItem) - discountTotal(orderItem) - voucherTotal(orderItem))"
          />
        </td>
      </tr>
      <tr
        class="grand-total-row"
      >
        <td>
          Total Due
        </td>
        <td class="cell-value">
          <formatted-number
            :value="orderItem.subtotal"
          />
        </td>
        <td class="cell-value">
          <formatted-number
            :value="orderItem.taxAmount"
          />
        </td>
        <td class="cell-value">
          <formatted-number
            :value="orderItem.total"
          />
        </td>
      </tr>
    </tbody>
  </q-markup-table>
</template>

<script>
import FormattedNumber from 'src/modules/admin/components/FormattedNumber'

export default {
  name: 'OrderItemPriceTable',
  components: { FormattedNumber },
  props: {
    orderItem: {
      type: Object,
      required: true
    }
  },
  created () {
  },
  methods: {
    originalSubtotal (orderItem) {
      return orderItem.setAsGross ? orderItem.priceSetByCinema - orderItem.taxFromGross(orderItem.priceSetByCinema) : orderItem.priceSetByCinema
    },
    originalTax (orderItem) {
      return orderItem.setAsGross ? orderItem.taxFromGross(orderItem.priceSetByCinema) : orderItem.taxFromNet(orderItem.priceSetByCinema)
    },
    originalTotal (orderItem) {
      return orderItem.setAsGross ? orderItem.priceSetByCinema : orderItem.priceSetByCinema + orderItem.taxFromNet(orderItem.priceSetByCinema)
    },
    voucherTotal (orderItem) {
      return orderItem.voucherAmount + (orderItem.hasTax ? orderItem.taxFromNet(orderItem.voucherAmount) : 0)
    },
    discountTotal (orderItem) {
      return orderItem.discountAmount + (orderItem.hasTax ? orderItem.taxFromNet(orderItem.discountAmount) : 0)
    }
  },
  configuration: ['currentCircuit', 'currentSite']
}

</script>

<style lang="scss">
th,
.bold-label {
  font-weight: bold;
}

.sub-label {
  padding-left: 1em;
}

.cell-value {
  text-align: right;
}

.total-row td {
  border-top: solid 1px #444;
}

.top-total-row td {
  border-bottom: solid 1px #444;
}

.grand-total-row td {
  font-weight: bold;
  border-top: double 3px #444;
}
</style>
